export const Endpoint = () => `/api/v3/admin/extendlicense/`;
export const Csrf = () => `/api/v3/admin/token/`;

export interface Payload {
    id: string;
    licenseType: string;
    licenseExpiration: string;
}

export type Response = void;
